/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BuyerAgentCommissionPercentage1
 */
export interface BuyerAgentCommissionPercentage1 {
}

/**
 * Check if a given object implements the BuyerAgentCommissionPercentage1 interface.
 */
export function instanceOfBuyerAgentCommissionPercentage1(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BuyerAgentCommissionPercentage1FromJSON(json: any): BuyerAgentCommissionPercentage1 {
    return BuyerAgentCommissionPercentage1FromJSONTyped(json, false);
}

export function BuyerAgentCommissionPercentage1FromJSONTyped(json: any, ignoreDiscriminator: boolean): BuyerAgentCommissionPercentage1 {
    return json;
}

export function BuyerAgentCommissionPercentage1ToJSON(value?: BuyerAgentCommissionPercentage1 | null): any {
    return value;
}

